import axios from 'axios';

export const state = () => ({
    selected: null
});

export const getters = {
    selected: state => state.selected
};

export const mutations = {
    SET_SELECTED(state, item) {
        state.selected = item;
    }
};

export const actions = {
    setSelected({ commit }, channel) {
        commit('SET_SELECTED', channel);
    },

    getProfiles(vuexContext, { networks = [], businessProfileId = '' } = {}) {
        if (!Array.isArray(networks)) {
            networks = [networks];
        }

        const params = {};

        if (networks.length) {
            params.social_types = networks;
        }

        if (businessProfileId) {
            params.business_profile_id = businessProfileId;
        }

        return axios.$get('/v1/users', { params });
    },

    deleteProfile(vuexContext, id) {
        return axios.$delete(`/v1/users/${id}`);
    },

    getProfilesItems(vuexContext, { profileId, socialTypes, types }) {
        const params = {
            profileId,
            socialTypes,
            types
        };

        return axios.$get('/v1/users/items', { params });
    },

    getWebhookUrl(vuexContext, networkName) {
        return axios.$get('/webhooks', {
            params: {
                name: networkName
            }
        });
    }
};
